import { Injectable, OnDestroy } from '@angular/core';

import { CallService as LocalCallCallService } from '../../../local-call';
import { disuseStore, useStore } from '../../../store.decorator';
import { CallStatusService } from '../../../teams-call';

import { caAnalysisDialogReducer } from './ca-analysis-dialog.reducer';
import { CaAnalysisDialogState } from './ca-analysis-dialog.state';

@Injectable({ providedIn: 'root' })
export class CaAnalysisDialogService implements OnDestroy {
    state: CaAnalysisDialogState;

    constructor(
        readonly callStatusService: CallStatusService,
        readonly localCallCallService: LocalCallCallService,
    ) {
        useStore(this, 'coaching.caAnalysis', caAnalysisDialogReducer);
    }

    ngOnDestroy(): void {
        disuseStore(this);
    }
}
